define("shared/components/shared/profile-categorization/rewards-steps/tab/hashtag-usage", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div {{did-insert @triggerSegmentEvent}}>
    {{#if @showPartialRewards}}
      <div class="u--row u--p__lr__xs">
        <Shared::TableAnalytics
          @fullWidth={{true}}
          @isIndustry={{true}}
          @rows={{@industryHashtags}}
          @showIndustry={{false}}
          @socialProfile={{@socialProfile}}
        />
      </div>
    {{else}}
      <h4 class="u--p__lr__xs u--m__b__xs">
        {{t "shared_phrases.hashtag_performance"}}
        {{svg-jar "help" class="o--icon--sm"}}
        <EmberTooltip @event="hover">
          {{t (concat "profile_categorization.reports." @sectionName ".hashtag_usage.tooltip")}}
        </EmberTooltip>
      </h4>
  
      <div class="u--row u--p__lr__xs qa--categorize_reports_tab_2_content">
        <Shared::TableAnalytics
          @header={{@socialProfile.displayNickname}}
          @isCapitalized={{true}}
          @rows={{@profileHashtags}}
          @socialProfile={{@socialProfile}}
        />
  
        <Shared::TableAnalytics
          @header={{t (concat "profile_categorization.industries." @socialProfile.industry)}}
          @isIndustry={{true}}
          @rows={{@industryHashtags}}
          @socialProfile={{@socialProfile}}
        />
      </div>
    {{/if}}
  
    <p class="u--text--sm u--text--light u--m__b__0 u--m__t__xs u--m__l__xs">
      {{t "profile_categorization.reports.disclaimer"}}
    </p>
  </div>
  */
  {
    "id": "66vAIG3U",
    "block": "[[[11,0],[4,[38,0],[[30,1]],null],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"    \"],[10,0],[14,0,\"u--row u--p__lr__xs\"],[12],[1,\"\\n      \"],[8,[39,2],null,[[\"@fullWidth\",\"@isIndustry\",\"@rows\",\"@showIndustry\",\"@socialProfile\"],[true,true,[30,3],false,[30,4]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,\"h4\"],[14,0,\"u--p__lr__xs u--m__b__xs\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"shared_phrases.hashtag_performance\"],null]],[1,\"\\n      \"],[1,[28,[35,4],[\"help\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n      \"],[8,[39,5],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[[28,[37,6],[\"profile_categorization.reports.\",[30,5],\".hashtag_usage.tooltip\"],null]],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"u--row u--p__lr__xs qa--categorize_reports_tab_2_content\"],[12],[1,\"\\n      \"],[8,[39,2],null,[[\"@header\",\"@isCapitalized\",\"@rows\",\"@socialProfile\"],[[30,4,[\"displayNickname\"]],true,[30,6],[30,4]]],null],[1,\"\\n\\n      \"],[8,[39,2],null,[[\"@header\",\"@isIndustry\",\"@rows\",\"@socialProfile\"],[[28,[37,3],[[28,[37,6],[\"profile_categorization.industries.\",[30,4,[\"industry\"]]],null]],null],true,[30,3],[30,4]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n  \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__b__0 u--m__t__xs u--m__l__xs\"],[12],[1,\"\\n    \"],[1,[28,[35,3],[\"profile_categorization.reports.disclaimer\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@triggerSegmentEvent\",\"@showPartialRewards\",\"@industryHashtags\",\"@socialProfile\",\"@sectionName\",\"@profileHashtags\"],false,[\"did-insert\",\"if\",\"shared/table-analytics\",\"t\",\"svg-jar\",\"ember-tooltip\",\"concat\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/tab/hashtag-usage.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});